module.exports = __webpack_public_path__ + "static/python-19e43c1141b4f35fc9aae15f8df1ecc6.webp";